import { useRef, useCallback, Fragment } from 'react';
import { useCookies } from 'react-cookie';
import { useDispatch } from 'react-redux';
import styled, { withTheme } from 'styled-components';
import { TitleContainer } from './styles';
import { FovButton, FovFieldError, FovInput, H5, VerticalSpacer } from 'components';
import { Formik, Field } from 'formik';
import * as yup from 'yup';

import { updateOrgIdAdmin } from 'store/actions/adminActions/organizations';

const ButtonContainer = styled('div')`
    display: inline-flex;
    width: 100%;
    max-width: 25rem;
`;

const InputContainer = styled('div')`
    max-width: 25rem;
`;

export const Settings = withTheme(props => {
    const { organization } = props;
    const dispatch = useDispatch();
    const formikRef = useRef();

    const [ cookies ] = useCookies([ 'userAuth' ]);
    const token = cookies.archvision_token;
    const orgName = organization.name;

    const setRef = form => {
        if (!formikRef.current) {
            formikRef.current = form;
        }
    };

    const handleSubmit = useCallback(args => {
        const { values, setSubmitting } = args;
        const { name } = values;

        dispatch(updateOrgIdAdmin(token, organization.id, { name }))
            .finally(setSubmitting(false));
    }, [ organization.id ]);

    const defaults = {
        name: orgName || '',
    };

    const schema = yup.object().shape({
        name: yup.string().required('An organization name is required.'),
    });

    return (
        <Fragment>
            <TitleContainer>
                <H5>Settings</H5>
            </TitleContainer>
            <VerticalSpacer size={7} />
            <Formik
                initialValues={defaults}
                validationSchema={schema}
                onSubmit={(values, handlers) => {
                    const { setSubmitting } = handlers;
                    handleSubmit({ values, setSubmitting });
                }}
                validateOnChange={true}
            >
            {form => (
                <Fragment>
                {setRef(form)}
                Name
                <Field type='text' name='name'>
                {data => (
                    <InputContainer>
                        <FovInput
                            value={data.field.value}
                            placeholder={orgName}
                            {...data.field}
                            onChange={e => {
                                const newVal = e.target.value;
                                form.setFieldValue(data.field.name, newVal);
                            }}
                        />
                    </InputContainer>
                )}
                </Field>
                <FovFieldError name='name' />

                Subscription Formats
                <VerticalSpacer size={10} />

                <ButtonContainer>
                    <FovButton
                        type='submit'
                        disabled={form.isSubmitting}
                        onClick={form.handleSubmit}
                    >
                    Save Settings
                    </FovButton>
                </ButtonContainer>
                </Fragment>
            )}

            </Formik>
        </Fragment>
    );
});